import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/app/src/components/Analytics.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/app/src/components/LocaleSwitcher.tsx");
